import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";

export class SaCarrierFilter {

  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.clear();
  }

  idChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get id():any {
    return this.idChange.value;
  }
  set id(id:any) {

    this.idChange.next(id);
    this.emitChange("id", id);
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(name:any) {

    this.nameChange.next(name);
    this.emitChange("name", name);
  }

  saCarrierTypeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get saCarrierType():any {
    return this.saCarrierTypeChange.value;
  }
  set saCarrierType(saCarrierType:any) {

    this.saCarrierTypeChange.next(saCarrierType);
    this.emitChange("saCarrierType", saCarrierType);
  }


  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.id && this.id !== '') {
      params = params.set("id", this.id);
    }

    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }

    if (this.saCarrierType && this.saCarrierType !== '') {
      params = params.set("saCarrierType", this.saCarrierType);
    }


    return params;
  }

  public clear():void {
    this.id = undefined;
    this.name = undefined;
    this.saCarrierType = undefined;
  }
}
